import { render, staticRenderFns } from "./FavoriteDialog.vue?vue&type=template&id=3d29e480&scoped=true&"
import script from "./FavoriteDialog.vue?vue&type=script&lang=js&"
export * from "./FavoriteDialog.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteDialog.vue?vue&type=style&index=0&id=3d29e480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d29e480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d29e480')) {
      api.createRecord('3d29e480', component.options)
    } else {
      api.reload('3d29e480', component.options)
    }
    module.hot.accept("./FavoriteDialog.vue?vue&type=template&id=3d29e480&scoped=true&", function () {
      api.rerender('3d29e480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/ui/FavoriteDialog.vue"
export default component.exports